import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { Organization } from 'src/app/classes/organization';
import { PaymentService } from 'src/app/services/payment.service';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-pay-balance',
  templateUrl: './pay-balance.component.html',
  styleUrls: ['./pay-balance.component.scss'],
})
export class PayBalanceComponent  implements OnInit {
  contact = new CustomerContact()
  organization = new Organization()

  form = new FormGroup({
    card: new FormControl<string|number>('new_card', [Validators.required]),
    saveCard: new FormControl(false)
  })

  constructor(public activeModal: NgbActiveModal,
    private settingsService: SettingsService,
    private paymentService: PaymentService,
    private router: Router
  ) { }

  ngOnInit() {
    if(this.contact.default_card_id) {
      this.form.controls.card.setValue(this.contact.default_card_id)
    }

    this.settingsService.organization().subscribe(organization => {
      this.organization = organization
    })
  }
  
  abs(sum: number) {
    return Math.abs(sum)
  }

  pay() {
    const platform = Capacitor.getPlatform()

    this.paymentService.payment(this.organization.payment_api, { 
      card: this.form.controls.card.value, 
      amount: Math.abs(this.contact.balance), 
      title: $localize`Outstanding balance`, 
      locale: $localize.locale, 
      platform: platform,
      saveCard: this.form.controls.card.value == 'new_card' ? this.form.controls.saveCard.value : false
    }).subscribe(async payment => {
      if(this.form.controls.card.value == 'new_card') {
        if (platform != 'web') {
          await Browser.open({ url: payment.redirect_url })

          Browser.addListener('browserFinished', () => {
            Browser.removeAllListeners()
            this.activeModal.close()
            this.router.navigate(['/payments', payment.id])
          })

          this.paymentService.wait(`${payment.id}`).subscribe(async (payment) => {
            Browser.removeAllListeners()
            await Browser.close()
            this.activeModal.close()
            this.router.navigate(['/payments', payment.id])
          })
        }
        else {
          location.href = payment.redirect_url
        }  
      }
      else {
        this.activeModal.close()
        this.router.navigate(['/payments', payment.id])
      }
    })
  }
}
